
import React, { FC, useEffect, useState, ReactNode } from 'react'
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import toast from 'react-hot-toast';

import { RevRexSaleAccSyncGlI } from '../../../../resources/form-props';
import { RevRexSaleAccSyncGlValidate } from '../../../../resources/form-validator';
import { GL_VP, SELECT_CUSTOM_STYLE } from '../../../../resources/constants';
import SelectCustomOption from '../../../../components/SelectCustomOption';

interface Props {
    sales: any[],
    formRef: any,
    processData: ( data: any) => void,
    fechAccountList: (searchText: string, excludeVP: number[], includeVP: number[]) => Promise<any>
}
const SalesAccSync: FC<Props> = ({ sales, formRef, processData, fechAccountList }) => {

    const { control, register, handleSubmit, formState: { errors } } = useForm<RevRexSaleAccSyncGlI>({
        defaultValues: {
            sales: []
        },
        resolver: yupResolver(RevRexSaleAccSyncGlValidate)
    });
    const { fields, append: formAppend, remove: formRemove } = useFieldArray({
        control,
        name: "sales"
    });
    const [selectCustomStyle, setSlectCustomStyle] = useState<any>(SELECT_CUSTOM_STYLE('#fff'));

    useEffect(() => {
        if (sales.length) {
            sales.map((sale: any, index: number) => {
                const saleRecord = {
                    label: sale['name'],
                    value: sale['id']
                }
                formAppend({
                    sale_account_id: saleRecord,
                    gl_account: null
                })
            });
        }
    }, [sales])

    const _processData = (data: any) => {
        processData(data);
    }

    const filterSalesAccountList = async (inputValue: string) => {
        const data = await fechAccountList(inputValue, [], GL_VP.SALES_ACTIVITY.account)
        return data;
    };

    return (
        <div>
            <>{console.log('errors: ', errors)}</>
            <Form ref={formRef} onSubmit={handleSubmit(_processData)}>
                {
                    fields.map((field: any, index: number) => (
                        <div className="row mt-2" key={index}>
                            <div className="align-items-center col-md-6 d-flex justify-content-center">
                                <div className="form-group mb-0">
                                    <p className="lebel mb-0"><b>{fields[index]['sale_account_id']['label']}</b></p>
                                </div>
                            </div>
                            <div className="align-items-center col-md-6 d-flex justify-content-center">
                                <Form.Group className="col-sm-6" controlId="formBasicEmail">
                                    <Controller
                                        control={control}
                                        name={`sales.${index}.gl_account`}
                                        render={({ field: { value, onChange, onBlur, disabled } }) => (
                                            <AsyncSelect
                                                isClearable={true}
                                                defaultOptions
                                                loadOptions={filterSalesAccountList}
                                                onChange={onChange}
                                                className='vp-dropdown'
                                                menuPosition='fixed'
                                                value={value}
                                                defaultValue={value}
                                                isDisabled={disabled}
                                                styles={selectCustomStyle}
                                                components={{ Option: SelectCustomOption }}
                                            />
                                        )}
                                    />
                                    {
                                        errors && errors.sales && errors.sales[index] && errors.sales[index]?.gl_account && errors.sales[index]?.gl_account?.message && (
                                            <Form.Text className="d-flex text-danger">
                                                <strong>
                                                    {errors.sales[index]?.gl_account?.message as ReactNode || ''}
                                                </strong>
                                            </Form.Text>
                                        ) || ''
                                    }
                                </Form.Group>
                            </div>
                        </div>
                    ))
                }
                {
                    errors && errors.sales && errors.sales.message && (
                        <div className='mt-2 text-center'>
                            <span className="text-danger">
                                <strong>
                                    {errors.sales.message as ReactNode || ''}
                                </strong>
                            </span>
                        </div>

                    ) || ''
                }
                {
                    fields.length == 0 && (
                        <span>No Sale Account Found</span>
                    )
                }
            </Form>
        </div>
    )
}

export default SalesAccSync